export const allCustomerAttributesFields = `
  customer_desired_delivery_date
  customer_desired_due_date
  customer_po_number
  po_number
  sales_order_number
  shipping_pc_number
`;

export const allEODFields = `
  id
  category
  lastOfDay
  totalShipments
  magentoSuccess
  processing
  reportSuccess
  stagingSuccess
  gloviaSuccess
  camSuccess
  carrier
  reportFile
  gloviaAdjustmentFile
  gloviaAdjustmentFileHash
  gloviaAdjustmentFileProcessed
  runDate
  created_by
  updated_by
`;

export const allDieFields = `
  id
  isAvailable
  version
  name
  template_id
  tph
  usage_stats
  die_pressures {
    subAssemblyID
    subAssemblySKU
    subAssemblyName
    currentPressure
    defaultPressure
    diePressureRecords {
      oldPressure
      newPressure
      user
      order
      job
      timestamp
    }
  }
  horizon_id
  horizon_id_updatedAt
  comment
  laser_enabled
  updatedAt
`;

export const allHorizonFields = `
  id
  code
  name
  location
  type
  isAvailable
  hourlyMaxCapacity
  hourlyAvgCapacity
  hoursPerDay
`;

export const allHorizonStatFields = `
  id
  horizon_id
  die_id
  sheetsTotal
  timestamp
`;

export const allSettingFields = `
  id
  category
  createdAt
  description
  id
  name
  updatedAt
  value
`;

export const allYellowBagFields = `
  id
  category
  createdAt
  dueDate
  eodId
  orders
  shippingLabel
  status
  trackingNumber
  updatedAt
  weight
`;

export const allAmazonTransactionFields = `
  id
  transactionStatus
  poNumber
  label
  transactionId
  transactionMsgs{
    code
    message
    details
  }
  processedOn
  labelData {
    trackingNumber
    shipMethod
    zpl
  }
  retryAttempts
  createdAt
  updatedAt
`;

export const allProductSubAssemblyFields = `
  sku
  subAssemblyID
  manufacturerID
  materialName
  printOrder
  size
  sendToOki
  sendToHeidelberg
  youPrintSKU
  updatedAt
  createdAt
`;

export const allScrapFields = `
  id
  batchId
  category
  createdAt
  jobs
  material
  productSubAssembly
  scrapCodes {
    qty
    scrap {
      location
      category
      problem
      reason
      other_comment
    }
  }
  totalQty
  updatedAt
  user
`;

export const allBatchFields = `
  id
  activity_history {
    activity
    note
    timestamp
    user
  }
  category
  compKey
  finishing_type
  descriptiveName
  designatedScrap
  dfeDetails {
    DescriptiveName
    DeviceID
    Priority
    SubmissionTime
    QueueEntryID
    JdfURL
  }
  DFEqueueEntryID
  printingStartedAt
  isCustomSize
  submittedToDFEAt
  printedOnPress
  die
  increment_id
  includes_white_layer
  horizon_id
  material
  sides
  subAssembly
  dueDate
  batchStatus
  ptoBatchType
  resendCount
  jobs {
    subAssemblyID
    jobsList {
      jobId
      orderId
      productSubAssembly {
        ${allProductSubAssemblyFields}
      }
      descriptiveName
      pdfURL
      docCopies
      numPages
      reprint_pages {
        pageFrom
        pageTo
        totalPages
      }
    }
  }
  totalQty
  jobHistory
  jobHistoryList
  numberOfJobs
  scrap {
    ${allScrapFields}
  }
`;

export const allBinFields = `
  id
  category
  binNumber
  orderID
  shipmentID
`;

export const allHoldBinFields = `
  id
  category
  binNumber
  orderID
`;

export const allProductFields = `
  sku
  description
  coating
  cutting
  cutW
  cutH
  die_id
  special_handling
  isActive
  items_per_sheet
  material_description
  prepress_automated
  productName
  parent_sku
  product_type
  sides
  tariff_code
  laser_enabled
  templateId
  heidelbergTemplateId
  rfid_chipType
  rfid_chipMemory
  rfid_tech
  rfid_coo
  rfid_kind
  comment
  laminate
  fscCertification
`;

export const allJobFields = `
  id
  activity_history {
    activity
    note
    timestamp
    user
    comment
  }
  batchId
  batchIdHistory
  holdBinId
  horizonId
  category
  cuttingType
  cutting
  descriptiveName
  designateScrap
  docCopies
  dueDate
  isVariable
  isCustomSize
  includes_white_layer
  darkBorderScale
  makeToStock
  oaDetails {
    material {
      code
      faceprint
      glovia_description
      laser_enabled
      material_base
      material_id
      material_name
      material_type
      name
      printer_type
      subassembly_part_number
      coo_code
      country_origin
      features
    }
    template {
      code
      height
      image_url
      is_ptte
      labels_per_sheet
      laser_enabled
      name
      packaging_image_url
      image_code
      shape
      size
      template_id
      width
      cutting_pattern_pdf_url
      project_size_description
      project_snapshot_id
      project_stencil_id
      project_template_id
      is_custom_size
    }
    die {
      die_id
      code
      name
      template_id
      tph
    }
    pto {
      pto_preprint_id
      dpo_snapshot_id
      dpo_theme_name
      pto_design_name
      pto_specialty_inks
      pdf_url
    }
  }
  orderId
  pdfURL
  cutting
  cuttingPatternPdfURL
  originalPreferredCutting
  preferredCutting
  cutMachine
  originalCutMachine
  specs {
    type
    shape
    height
    width
    items_per_sheet
  }
  rfid_code
  rfid_description
  rfid_artworks {
    front {
      id
      preview_url
      download_url
      sheet_print_qty
      artwork_status
      sheet_total_qty
    }
    back {
      id
      preview_url
      download_url
      sheet_print_qty
      artwork_status
      sheet_total_qty
    }
  }
  rfid_artworkIdentifier
  rfid_url
  rfid_logo
  rfid_chipType
  rfid_chipMemory
  rfid_tech
  rfid_coo
  rfid_kind
  rfid_finishType
  rfid_approval_status
  rfid_inlayPartNumber
  rfid_approval_note
  rfid_missingSheetQty
  rfid_catalog
  rfid_doubleHitBlack
  rfid_printedOnPress_front
  rfid_printedOnPress_back
  previous_status
  product {
    ${allProductFields}
  }
  qty
  reprint
  reprintCount
  ghs
  retail
  jobLocation
  reprint_pages {
    pageFrom
    pageTo
    totalPages
  }
  numPages
  numJobsInOrder
  scrapQty
  sides
  sheets
  snapShotId
  status
  subAssembly
  thumbURL
  totalPrice
  unitPrice
  lineItemNumber
  itemsPerSheet
  lineNumber
  sellerItemNum
  specialRequest
  specialRequestInstructions
  amzCustomizedUrl
  updatedAt
`;

export const allFullOrderFields = `
  id
  category
  status
  previous_status
  product_group
  address {
    firstname
    lastname
    company
    street
    street2
    street3
    city
    region
    postcode
    country_id
    telephone
    validated
    softheader {
      ref
      dept
      location
      po
      customerPurchaseOrder
      customerAccountNum
      releaseNum
    }
  }
  activity_history {
    activity
    note
    user
    timestamp
    comment
  }
  shipment {
    shipping_method
    custom_shipping_method
    customer_desired_due_date
    customer_desired_delivery_date
    shipping_description
    shipped_method
    name
    previous_shipping_method
    production_due_date
    estimated_delivery_date
    estimated_delivery_date_to
    type
  }
  customer {
    firstname
    lastname
    email
    outsource
    dropship
  }
  jobs {
    ${allJobFields}
  }
  reprint
  reprintCount
  orderDate
  dueDate
  totalPrice
  yellowBagID
  marketplaceID
  transactionID
  gloviaWOProcessed
  customerAttributes {
    ${allCustomerAttributesFields}
  }
  gloviaWCProcessed
  gloviaCancelProcessed
  gloviaAdjProcessed
  referenceId
  camProcessed
  weight
  updatedAt
  createdAt
  promotion
  orderType
  poNumber
  salesOrderNumber
  customAmazonOrder
`;

export const allOrderFields = `
  id
  category
  status
  previous_status
  product_group
  address {
    firstname
    lastname
    company
    street
    street2
    street3
    city
    region
    postcode
    country_id
    telephone
    validated
    softheader {
      ref
      dept
      location
      po
      customerPurchaseOrder
      customerAccountNum
      releaseNum
    }
  }
  billing {
    firstname 
    lastname  
    street    
    street2   
    street3   
    city      
    region    
    postcode  
    country_id
    telephone 
  }
  activity_history {
    activity
    note
    user
    timestamp
    comment
  }
  shipment {
    shipping_method
    shipping_description
    shipped_method
    custom_shipping_method
    customer_desired_due_date
    customer_desired_delivery_date
    name
    previous_shipping_method
    production_due_date
    estimated_delivery_date
    estimated_delivery_date_to
    type
  }
  customer {
    firstname
    lastname
    email
    outsource
    dropship
  }
  jobs
  reprint
  reprintCount
  orderDate
  dueDate
  totalPrice
  yellowBagID
  marketplaceID
  transactionID
  gloviaWOProcessed
  customerAttributes {
    ${allCustomerAttributesFields}
  }
  gloviaWCProcessed
  gloviaCancelProcessed
  gloviaAdjProcessed
  referenceId
  camProcessed
  weight
  updatedAt
  createdAt
  promotion
  orderType
  poNumber
  salesOrderNumber
  customerSuppliedAccount {
    carrier_type
    shipper_account_number
    name
    company
    street
    city
    region
    postalCode
    country
    phone
    allow_speed_upgrade
  }
  customAmazonOrder
  `;

export const allShipmentFields = `
  id
  category
  createdAt
  updatedAt
  address {
    city
    company
    country_id
    entity_id
    email
    firstname
    lastname
    postcode
    region
    street
    street2
    street3
    telephone
    validated
    softheader {
      ref
      dept
      location
      po
      customerPurchaseOrder
      customerAccountNum
      releaseNum
    }
  }
  activity_history {
    activity
    note
    user
    timestamp
    comment
  }
  accessory
  bin
  carrier
  oldCarrier
  createdBy
  deliveryConfirmation
  dueDate
  eodId
  expectedDate
  customerDesiredDueDate
  customerDesiredDelDate
  intlInvoice
  jobs
  notes
  oldServiceType
  operatorOverrideAdjust
  orderId
  packages {
    packageNumber
    packageType
    shippingLabel
    trackingNumber
    weight
    material {
      materialId
      count
    }
  }
  isLTL
  shipmentCharges {
    chargeType
    currencyCode
    monetaryValue
  }
  serviceType
  shipmentStatus
  shipmentType
  shippedBy
  totalWeight
  trackingNumberUPS
  trackingNumberUSPS
  trackingNumberFEDEX
  transactionID
  units
  yellowBagID
  pendingShipment
  magentoResp
  promotion
`;

export const allTemplateFields = `
  id
  createdAt
  updatedAt
  barcodeHeight
  barcodePosition
  barcodeRotate
  barcodeShow
  barcodeWidth
  barcodeX
  barcodeY
  cells {
    rO
    xO
    xS
    yO
    yS
  }
  coatingSignX
  coatingSignY
  coatingSignRotate
  comments
  commentsRotate
  commentsShow
  commentsX
  commentsY
  cuttingSignX
  cuttingSignY
  cuttingSignRotate
  dueDateRotate
  dueDateShow
  dueDateX
  dueDateY
  finishBarcodeHeight
  finishBarcodePosition
  finishBarcodeRotate
  finishBarcodeShow
  finishBarcodeWidth
  finishBarcodeX
  finishBarcodeY
  finishCode
  finishCodeX
  finishCodeY
  finishingSignsShow
  generatedDateRotate
  generatedDateShow
  generatedDateX
  generatedDateY
  infoStripShow
  infoStrip_dueDate_fontSize
  infoStrip_finishCode_fontSize
  infoStrip_generatedDate_fontSize
  infoStrip_numberOfCopies_fontSize
  infoStrip_jobId_fontSize
  infoStrip_orderId_fontSize
  infoStrip_comments_fontSize
  infoStrip_comments_X
  infoStrip_comments_Y
  infoStrip_finishingSigns_scale_X
  infoStrip_finishingSigns_scale_Y
  infoStrip_numberOfJobs_show
  infoStrip_numberOfJobs_fontSize
  infoStrip_numberOfJobs_position_X
  infoStrip_numberOfJobs_position_Y
  infoStrip_numberOfJobs_rotate
  infoStrip_productName_fontSize
  infoStrip_productName_rotate
  infoStrip_productName_X
  infoStrip_productName_Y
  infoStrip_textSubAssembly_fontSize
  infoStrip_textSubAssembly_position_X
  infoStrip_textSubAssembly_position_Y
  infoStrip_textSubAssembly_rotate
  infoStrip_repeat_count
  infoStrip_repeat_distanceX
  infoStrip_repeat_distanceY
  infoStrip_textVariableQTY_fontSize
  infoStrip_textVariableQTY_position_X
  infoStrip_textVariableQTY_position_Y
  infoStrip_textVariableQTY_rotate
  inlineJobCardShow
  inlineJobCardXAdjustment
  inlineJobCardYAdjustment
  jobCardDuplex
  jobIdRotate
  jobIdShow
  jobIdX
  jobIdY
  marginBottom
  marginLeft
  marginRight
  marginTop
  numberOfCells
  numberOfCopiesRotate
  numberOfCopiesShow
  numberOfCopiesX
  numberOfCopiesY
  orderIdRotate
  orderIdShow
  orderIdX
  orderIdY
  overlayFile
  overlayOnTopFile
  productName
  productNameRotate
  productNameShow
  productNameX
  productNameY
  speacialHandlingRotate
  speacialHandlingSignX
  speacialHandlingSignY
  templateName
  unitOfMeasurement
`;

export const allUserFields = `
  email
  adminVerified
  role
  team
  workingRoles
  workingShifts
  userVerified
`;

export const allInvalidJobScan = `
  id
  jobId
  orderId
  category
  location
  jobStatus
  shipmentStatus
  user
  timestamp
`;

export const allJobLocationFields = `
  id
  jobId
  orderId
  category
  location
  qty
  numJobs
  dueDate
  docCopies
  numPages
  timestamp
`;

export const allRoleFields = `
  code
  name
  category
  hourlyMaxCapacity
  hourlyAvgCapacity
  hoursPerDay
  isActive
`;

export const allCapacityConfigFields = `
  compKey
  configDate
  shift
  category
  startTime
  endTime
  break1StartTime
  break1EndTime
  break2StartTime
  break2EndTime
  workingHours
  workloadBySheet
  workloadByBatch
  workloadByJob
  workloadByOrder
  compWorkBySheet
  compWorkByBatch
  compWorkByJob
  compWorkByOrder
  binningEmployees {
    email
    team
    workingRoles
    workingShifts
  }
  binningHourlyAvgCapacity
  binningHoursPerDay
  binningCompWorkBySheet
  packingEmployees {
    email
    team
    workingRoles
    workingShifts
  }
  packingHourlyAvgCapacity
  packingHoursPerDay
  packingCompWorkBySheet
  horizons {
    id
    code
    name
    type
    isAvailable
    isUsed
    hourlyAvgCapacity
    hoursPerDay
    operatorHourlyAvgCapacity
    operatorHoursPerDay
    compWorkBySheet
    compWorkByBatch
    employees {
      email
      team
      workingRoles
      workingShifts
    }
  }
  createdAt
  updatedAt
`;

export const allRfidTransitionFields = `
  id
  fromStatus
  toStatus
  timestamp
  operator
  isReprint
  reasonNote
`;

export const allRfidPaperConsumptionFields = `
  transitionId
  front_sheets_used
  backSheetsUsed
  frontSheetsWasted
  back_sheets_scrap
  sheetSize
  wasteReason
  timestamp
  operator
  isReprint
`;

export const allRfidInlayConsumptionFields = `
  transitionId
  inlay_sheets_used
  inlaySheetsWasted
  inlayPartNumber
  missingSets
  wasteReason
  timestamp
  operator
  isReprint
`;

export const allRfidLaminateConsumptionFields = `
  transitionId
  frontLaminateFeetUsed
  backLaminateFeetUsed
  frontLaminateWasted
  back_laminate_scrap
  laminateType
  wasteReason
  timestamp
  operator
  isReprint
`;

export const allRfidProductionOutputFields = `
  transitionId
  cards_produced
  cardsScrapped
  excessCards
  qualityNotes
  timestamp
  operator
`;

export const allRfidProductionFields = `
  job_id
  order_id
  rfid_code
  rfid_chip_type
  rfid_tech
  rfid_finish_type
  qty_ordered
  reprint_count
  inlay_part_number
  product
  laminate_type
  cumulative_totals {
    total_front_sheets_used
    total_back_sheets_used
    total_front_sheets_scrap
    total_back_sheets_scrap
    total_inlay_sheets_used
    total_inlay_sheets_scrap
    total_front_laminate_feet_used
    total_back_laminate_feet_used
    total_front_laminate_scrap
    total_back_laminate_scrap
  }
  created_at
  updated_at
`;

export const allRfidAggregatedConsumptionFields = `
  paperConsumption {
    totalFrontSheets
    totalBackSheets
    totalWastedFrontSheets
    totalWastedBackSheets
  }
  inlayConsumption {
    totalInlaySheets
    totalWastedInlaySheets
    totalMissingSets
  }
  laminateConsumption {
    totalFrontLaminateFeet
    totalBackLaminateFeet
    totalWastedFrontLaminateFeet
    totalWastedBackLaminateFeet
  }
  productionOutput {
    totalCardsProduced
    totalCardsScrapped
    totalExcessCards
  }
`;



// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/ngrx/graphql.ts